"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubFiscaliteApplicableScpi = void 0;
exports.ESubFiscaliteApplicableScpi = {
    revenusFonciers: "revenusFonciers",
    dividendes: "dividendes",
    pasDeFiscalite: "pasDeFiscalite",
    neSaisPas: "neSaisPas",
};
